import { adminConsoleMessages, appRoutes, canManageFiduciarie, useAppSelector } from 'azshared';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiArrowRight } from '@mdi/js';
import { AppSvgIcon } from '../../../components/svg-icon/app-svg-icon';
import './admin-dashboard.scss';

export const AdminDashboardPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const showFiduciarie = useAppSelector((state) => canManageFiduciarie(state.features.adminConsole.common.user));

  const handleNavigateCustomerService = useCallback(() => {
    navigate(appRoutes.CustomerService);
  }, [navigate]);

  const handleNavigateFiduciarie = useCallback(() => {
    navigate(appRoutes.AdminFiduciarie);
  }, [navigate]);

  return (
    <div className='admin-dashboard'>
      <h1 className='admin-dashboard-title'>{formatMessage(adminConsoleMessages.dashboardTitle)}</h1>

      <div className='admin-dashboard-cards'>
        <div className='admin-dashboard-card'>
          <div className='admin-dashboard-card-header'>
            <AppSvgIcon icon='customer-service-blue' />
            <h3 className='admin-dashboard-card-title'>{formatMessage(adminConsoleMessages.customerServiceCardTitle)}</h3>
          </div>
          <p className='admin-dashboard-card-description'>
            {formatMessage(adminConsoleMessages.customerServiceCardDescription)}
          </p>
          <div className='admin-dashboard-card-action' onClick={handleNavigateCustomerService} role='button' tabIndex={0}>
            <span>{formatMessage(adminConsoleMessages.goToFunctionality)}</span>
            <Icon path={mdiArrowRight} size={0.75} className='action-arrow' />
          </div>
        </div>

        {showFiduciarie && (
          <div className='admin-dashboard-card'>
            <div className='admin-dashboard-card-header'>
              <AppSvgIcon icon='fiduciarie-blue' />
              <h3 className='admin-dashboard-card-title'>{formatMessage(adminConsoleMessages.fiduciarieCardTitle)}</h3>
            </div>
            <p className='admin-dashboard-card-description'>
              {formatMessage(adminConsoleMessages.fiduciarieCardDescription)}
            </p>
            <div className='admin-dashboard-card-action' onClick={handleNavigateFiduciarie} role='button' tabIndex={0}>
              <span>{formatMessage(adminConsoleMessages.goToFunctionality)}</span>
              <Icon path={mdiArrowRight} size={0.75} className='action-arrow' />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
